import React from 'react';
import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';
import CoreModal from '@sparefoot/react-core/Modal';
import classnames from 'classnames';
import useBodyClassName from 'hooks/useBodyClassName';

import './Modal.scss';

export default function Modal({
	showing,
	hasDarkTitleBackground = false,
	...rest
}) {
	useBodyClassName(showing ? 'no-scroll' : '');

	return (
		<CSSTransition
			classNames="transition-fade-in"
			in={showing}
			unmountOnExit
			timeout={150}
		>
			<CoreModal
				{...rest}
				className={classnames(rest.className, 'ss-modal', {
					'dark-title-bg': hasDarkTitleBackground,
					'light-title-bg': !hasDarkTitleBackground,
				})}
			/>
		</CSSTransition>
	);
}

Modal.propTypes = {
	className: PropTypes.string,
	showing: PropTypes.bool,
	hasDarkTitleBackground: PropTypes.bool,
};
